/** Staff “view as architect” — must not reuse supplier `viewAs=<orgId>`. */
export const ARCHITECT_PREVIEW_AS = 'architect';

export function parseArchitectPreviewUid(
  search: string | URLSearchParams | null | undefined,
): string | null {
  const params = typeof search === 'string'
    ? new URLSearchParams(search.startsWith('?') ? search.slice(1) : search)
    : search || new URLSearchParams();
  if (params.get('previewAs') !== ARCHITECT_PREVIEW_AS) return null;
  const uid = params.get('uid')?.trim() || '';
  return uid || null;
}

export function buildArchitectPortalPreviewSearch(uid: string): string {
  const id = uid.trim();
  if (!id) return '';
  const params = new URLSearchParams();
  params.set('previewAs', ARCHITECT_PREVIEW_AS);
  params.set('uid', id);
  return `?${params.toString()}`;
}

export function applyArchitectPortalPreviewToSearchParams(
  current: URLSearchParams,
  uid: string | null | undefined,
): URLSearchParams {
  const next = new URLSearchParams(current);
  const id = uid?.trim() || '';
  if (!id) {
    next.delete('previewAs');
    next.delete('uid');
    return next;
  }
  next.set('previewAs', ARCHITECT_PREVIEW_AS);
  next.set('uid', id);
  return next;
}
